<template>
    <div class="block-slider">
        <div class="container">
            <div class="block-swiper-container swiper-container wide-slider">
                <div class="swiper-wrapper">
                    <div class="swiper-slide" :key="slide.text" v-for="slide in slides">
                        <div class="text col-l-8 col-m-8 col-s-12">
                            <div class="content" v-html="slide.text"></div>
                        </div>
                        <div
                            class="image col-l-4 col-m-4 col-s-12"
                            v-if="slide.image.url"
                            :style="{ 'background-image': 'url( ' + slide.image.url + ' )', backgroundRepeat: 'no-repeat', backgroundPosition: 'center', backgroundSize: 'cover'}"
                        ></div>
                    </div>
                </div>
                <div class="block-swiper-prev wide-slider-prev"></div>
                <div class="block-swiper-next wide-slider-next"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["blockdata"],
    name: "block-slider",
    data() {
        return {
            slides: this.blockdata.slides
        };
    },
    mounted: function() {
        this.awardsSwiper = new Swiper(".block-swiper-container", {
            loop: true,
            slidesPerView: "auto",
            centeredSlides: true,
            initialSlide: 0,
            nextButton: ".block-swiper-next",
            prevButton: ".block-swiper-prev",
            speed: 500
        });
    }
};
</script>


// WEBPACK FOOTER //
// BlockSlider.vue?364ffc81